import { PLUGIN_AUTH_PROVIDERS } from "metabase/plugins";
import MetabaseSettings from "metabase/utils/settings";

PLUGIN_AUTH_PROVIDERS.providers.push((providers) => {
  // ATKV: in OIDC-exclusive mode, never offer password login in the UI.
  // (Server-side enforcement lives in metabase.session.api/login.)
  if (MetabaseSettings.get("atkv-oidc-exclusive")) {
    return providers;
  }

  const passwordProvider = {
    name: "password",
    // circular dependencies
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    Button: require("metabase/auth/components/PasswordButton").PasswordButton,
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    Panel: require("metabase/auth/components/PasswordPanel").PasswordPanel,
  };

  return [...providers, passwordProvider];
});
